<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="update-card-data">
      <div class="second-headboard">
        <h1>{{ 'customerCards.updateCardTitle' | translate }}</h1>
      </div>

      @if (loaded && card) {
        <section class="info-section">
          <h1>{{ 'customerCards.cardInformation' | translate }}</h1>
          <dl class="card-info">
            <div>
              <dt>{{ 'customerCards.cardNumber' | translate }}</dt>
              <dd>{{ card.maskCreditCard }}</dd>
            </div>
            <div>
              <dt>{{ 'customerCards.provider' | translate }}</dt>
              <dd>{{ card.provider }}</dd>
            </div>
            <div>
              <dt>{{ 'customerCards.name' | translate }}</dt>
              <dd>{{ card.holder }}</dd>
            </div>
            <div>
              <dt>{{ 'customerCards.expiration' | translate }}</dt>
              <dd>{{ card.expiration }}</dd>
            </div>
          </dl>
        </section>

        <section class="info-section">
          <h1>{{ 'customerCards.billingInformation' | translate }}</h1>

          @if (currentAddress) {
            @if (!showPicker) {
              <div class="current-address">
                <div class="current-address__body">
                  <span class="current-address__label">{{ 'customerCards.currentAddress' | translate }}</span>
                  <span class="current-address__line">{{ currentAddress.address }}</span>
                  <span class="current-address__detail">{{ currentAddressDetail }}</span>
                </div>
                <button type="button" class="change-btn" (click)="openPicker()">
                  {{ 'customerCards.changeAddress' | translate }}
                </button>
              </div>
            }
          } @else {
            <p class="no-address-notice">{{ 'customerCards.cardNoAddressNotice' | translate }}</p>
          }

          @if (showPicker) {
            <app-billing-address-picker
              [addresses]="addresses"
              [currentAddressId]="currentAddressId"
              [cardId]="card.id"
              [customerId]="customerId"
              (selectionChange)="onSelectionChange($event)"
              (busyChange)="onBusyChange($event)"
              (addressCreated)="onAddressCreated($event)">
            </app-billing-address-picker>
          }

          @if (hasChange) {
            <p class="save-hint">
              {{ 'customerCards.willUseOnSave' | translate }} <strong>{{ selectedStreet }}</strong>
            </p>
          }
        </section>
      }
    </div>

    <div class="options-buttons">
      <button type="button" class="back-btn" (click)="cancel()">{{ 'customerCards.cancel' | translate }}</button>
      <button type="button" class="continue-btn" [disabled]="!canSave" (click)="save()">
        {{ 'customerCards.save' | translate }}
      </button>
    </div>
  </div>
</body>
